import { fromJS } from "immutable"

// action creators
import * as djangioActionCreators from "shared/djangio/action-creators"
import { destroyDashboardStore } from "app/static/frontend/dashboards/action-creators"
import { segueToProfile } from "app/static/frontend/global-action-creators"

// action types
import dashboardsActionTypes, {
    loadWidgetTemplateListActionDict,
    postWidgetTemplateSelectionActionDict
} from "app/static/frontend/dashboards/action-types"

import constants from "app/static/frontend/dashboards/constants"

/**
 * Load a page of WidgetTemplates from the server
 *
 * @name getWidgetTemplates
 * @function
 * @param {Number} offset - the start of the page to fetch
 * @param {Object} filters - object with keys as filters to apply and values as values for those filters
 * @returns {Promise}  returns result of resourceGetList
 */
export const getWidgetTemplates = ({offset=0, filters={}}) =>
    djangioActionCreators.resourceGetList(
        DjangIO.app.widgets.models.WidgetTemplate,
        loadWidgetTemplateListActionDict,
        {
            ...filters,
            offset,
            limit: constants.widgetTemplateLimit,
        },
        {
            limit: constants.widgetTemplateLimit,
        },
    )

/**
 * Clears the stored widget templates from the store
 */
export const clearWidgetTemplateList = () => ({
    type: dashboardsActionTypes.WIDGET_CREATE_FORM_CLEAR_TEMPLATE_LIST,
})

/**
 * Submit the selection from the "new from template" tab, refresh the dashboard
 *
 * @name submitWidgetTemplateSelection
 * @function
 * @param {Number} dashboardId - the ID of the dashbaord to post to and then segue to
 * @param {Object} widget - the "widget" configuration obj to be used as a template, normally a field from WidgetTemplate
 * @returns {Object}  returns result of the last dispatch this function calls
 */
export const submitWidgetTemplateSelection = ({dashboardId, widget={}}) =>
    async dispatch => {
        if (widget.meta && widget.meta.id) {
            // if for any reason we are passing the id, as we want to use this widget configuration
            // as a template, we should blank it, so that a new id is generated for the new widget
            widget.meta.id = undefined
        }
        await dispatch(djangioActionCreators.sendAction(
            DjangIO.app.widgets.models.Dashboard.objects.get(dashboardId),
            postWidgetTemplateSelectionActionDict,
            {
                action: "widget",
                kwargs: widget,
                method: "post",
            }
        ))

        await dispatch(destroyDashboardStore({
            id: dashboardId
        }))

        return dispatch(segueToProfile(
            {
                id: dashboardId,
                extraUrlParameters: "?editing=true",
            },
            DjangIO.app.models.QuorumDataType.dashboard.value,
        ))
    }
